import React, { Children, memo } from 'react';
import classNames from 'classnames/bind';
import { CarouselWithNavigation } from "../../../Carousel/components/CarouselWithNavigation";
import { Carousel } from "../../../Carousel";
import { useIsDesktopDimension } from "../../../../hooks/useGetDimensionGroup";
import styles from "./styles.module.pcss";
import { usePrepareMainServices } from "./hooks/usePrepareMainServices";
var cn = classNames.bind(styles);
var _ServiceTileLayout = function _ServiceTileLayout(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'tile' : _ref$type,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'l' : _ref$size,
    className = _ref.className,
    children = _ref.children;
  var settings = usePrepareMainServices();
  var isDesktop = useIsDesktopDimension();
  var ComponentCarousel = isDesktop ? CarouselWithNavigation : Carousel;
  if (type === 'tile' || Children.count(children) <= settings.slidesPerView) {
    return /*#__PURE__*/React.createElement("div", {
      className: cn("layout-tile-".concat(size), className),
      "data-t-id": "components-ServiceTileLayout"
    }, children);
  }
  if (type === 'carousel') {
    return /*#__PURE__*/React.createElement("div", {
      className: cn('wrapper')
    }, /*#__PURE__*/React.createElement(ComponentCarousel, {
      className: cn('carousel'),
      paginatePadding: false,
      settings: settings
    }, children));
  }
  return null;
};
export var ServiceTileLayout = /*#__PURE__*/memo(_ServiceTileLayout);